/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Controller } from './Controller';
import {
    ControllerFromJSON,
    ControllerFromJSONTyped,
    ControllerToJSON,
} from './Controller';
import type { ControllerStats } from './ControllerStats';
import {
    ControllerStatsFromJSON,
    ControllerStatsFromJSONTyped,
    ControllerStatsToJSON,
} from './ControllerStats';
import type { Edition } from './Edition';
import {
    EditionFromJSON,
    EditionFromJSONTyped,
    EditionToJSON,
} from './Edition';
import type { LicenseStats } from './LicenseStats';
import {
    LicenseStatsFromJSON,
    LicenseStatsFromJSONTyped,
    LicenseStatsToJSON,
} from './LicenseStats';
import type { MinimalPartnerGroup } from './MinimalPartnerGroup';
import {
    MinimalPartnerGroupFromJSON,
    MinimalPartnerGroupFromJSONTyped,
    MinimalPartnerGroupToJSON,
} from './MinimalPartnerGroup';
import type { ProductType } from './ProductType';
import {
    ProductTypeFromJSON,
    ProductTypeFromJSONTyped,
    ProductTypeToJSON,
} from './ProductType';
import type { Region } from './Region';
import {
    RegionFromJSON,
    RegionFromJSONTyped,
    RegionToJSON,
} from './Region';
import type { TenantType } from './TenantType';
import {
    TenantTypeFromJSON,
    TenantTypeFromJSONTyped,
    TenantTypeToJSON,
} from './TenantType';

/**
 * 
 * @export
 * @interface TenantList
 */
export interface TenantList {
    /**
     * 
     * @type {string}
     * @memberof TenantList
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof TenantList
     */
    readonly shortId: string;
    /**
     * 
     * @type {string}
     * @memberof TenantList
     */
    readonly name: string;
    /**
     * 
     * @type {Controller}
     * @memberof TenantList
     */
    readonly controller: Controller | null;
    /**
     * 
     * @type {Edition}
     * @memberof TenantList
     */
    readonly edition: Edition | null;
    /**
     * 
     * @type {Array<Edition>}
     * @memberof TenantList
     */
    readonly editions: Array<Edition> | null;
    /**
     * 
     * @type {Region}
     * @memberof TenantList
     */
    readonly region: Region;
    /**
     * 
     * @type {LicenseStats}
     * @memberof TenantList
     */
    readonly stats: LicenseStats;
    /**
     * 
     * @type {ControllerStats}
     * @memberof TenantList
     */
    readonly controllerStats: ControllerStats;
    /**
     * 
     * @type {Date}
     * @memberof TenantList
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {MinimalPartnerGroup}
     * @memberof TenantList
     */
    readonly partner: MinimalPartnerGroup | null;
    /**
     * 
     * @type {TenantType}
     * @memberof TenantList
     */
    readonly tenantType: TenantType;
    /**
     * 
     * @type {Array<ProductType>}
     * @memberof TenantList
     */
    readonly licenseTypes: Array<ProductType>;
}

/**
 * Check if a given object implements the TenantList interface.
 */
export function instanceOfTenantList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "shortId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "controller" in value;
    isInstance = isInstance && "edition" in value;
    isInstance = isInstance && "editions" in value;
    isInstance = isInstance && "region" in value;
    isInstance = isInstance && "stats" in value;
    isInstance = isInstance && "controllerStats" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "partner" in value;
    isInstance = isInstance && "tenantType" in value;
    isInstance = isInstance && "licenseTypes" in value;

    return isInstance;
}

export function TenantListFromJSON(json: any): TenantList {
    return TenantListFromJSONTyped(json, false);
}

export function TenantListFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shortId': json['short_id'],
        'name': json['name'],
        'controller': ControllerFromJSON(json['controller']),
        'edition': EditionFromJSON(json['edition']),
        'editions': (json['editions'] === null ? null : (json['editions'] as Array<any>).map(EditionFromJSON)),
        'region': RegionFromJSON(json['region']),
        'stats': LicenseStatsFromJSON(json['stats']),
        'controllerStats': ControllerStatsFromJSON(json['controller_stats']),
        'createdAt': (new Date(json['created_at'])),
        'partner': MinimalPartnerGroupFromJSON(json['partner']),
        'tenantType': TenantTypeFromJSON(json['tenant_type']),
        'licenseTypes': ((json['license_types'] as Array<any>).map(ProductTypeFromJSON)),
    };
}

export function TenantListToJSON(value?: TenantList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

